import Icon from '../components/Icon.vue'

Icon.register({"h-square":{"width":448,"height":512,"paths":[{"d":"M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM336 128H304C295.2 128 288 135.2 288 144V224H160V144C160 135.2 152.8 128 144 128H112C103.2 128 96 135.2 96 144V368C96 376.8 103.2 384 112 384H144C152.8 384 160 376.8 160 368V288H288V368C288 376.8 295.2 384 304 384H336C344.8 384 352 376.8 352 368V144C352 135.2 344.8 128 336 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/h-square.js
// module id = qQgA
// module chunks = 0